import request from '@/utils/request'
const baseUrl = 'https://light.taiott.com/v1'
export default {
	/**
	 * 七牛 获取静态拉流地址
	**/
	getStreamUrl( params={} ) {
		return request({
	    url: baseUrl + '/videoMonitor/getStaticStreamAddress',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 七牛 启动设备拉流
	**/
	startFlow() {
		return request({
		url: baseUrl + '/videoMonitor/pullFlow',
		method: 'POST'
	  })
	},
	
	/**
	 * 七牛 停止设备拉流
	**/
	stopFlow() {
		return request({
		url: baseUrl + '/videoMonitor/stopFlow',
		method: 'POST'
	  })
	},

	/**
	 * 七牛 PTZ云端控制
	 *  @param   	cmd  控制  ( left(向左), right(向右), up(向上), down(向下), leftup(左上)
               ,rightup(右上), leftdown(左下), rightdown(右下), zoomin(缩小)
               ,zoomout(放大),stop(停止PTZ操作) ) 
		@param   	speed 调节速度 (1-10, 默认位5)
		@return 	code msg
```
	**/
	videoControl(data) {
		return request({
		url: baseUrl + '/videoMonitor/cloudPTZControl',
		method: 'POST',
		data
	  })
	}

	
}